import { ESdChangeReason, LeftPanelType, ViewPart, Visibility } from "@kuika/kuika-cl-model";
import { IWithSDProps, withSD } from "../../../shared/hoc/screen-design-consumer";
import { PureSdComponent } from "../../../shared/pure-sd";
import KuikaButton from "../../ui-kit/kuika-button/kuika-button";
import KuikaSvg from "../../ui-kit/kuika-svg/kuika-svg";
import { isLeftPanelButtonActive } from "./left-panel-rail";

export interface IComponentsButtonState {}

export interface IComponentsButtonProps {
  onMenuItemClick?: (panelType: LeftPanelType) => void;
}

class ComponentsButton extends PureSdComponent<IComponentsButtonProps & IWithSDProps, IComponentsButtonState> {
  constructor(props: IComponentsButtonProps & IWithSDProps) {
    super(props);
    this.state = {};
  }

  handleClick = () => {
    if (this.props.onMenuItemClick) {
      this.props.onMenuItemClick(LeftPanelType.Component);
    } else {
      this.props.sd.setActiveLeftPanelByClick(LeftPanelType.Component);
    }
  };

  render() {
    return (
      <>
        {this.props.sd.getVisibility(ViewPart.ComponentsButton) === Visibility.Visible && (
          <KuikaButton
            data-testid="leftMenuElementsTabButton"
            data-onboarding-id="left_menu_elements"
            type="tertiary"
            size="md"
            isIcon
            color="neutral"
            active={isLeftPanelButtonActive(this.props.sd, LeftPanelType.Component)}
            onClick={this.handleClick}
          >
            <KuikaSvg name="square-plus" width={22} height={22} pointer />
          </KuikaButton>
        )}
      </>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    return false;
  };
}

const componentsButton = withSD<IComponentsButtonProps>(ComponentsButton);
export { componentsButton as ComponentsButton };
